import { RouteConfig } from 'vue-router';


const Home = () => import(/* webpackChunkName: "Main" */  '../home/home.vue');
const Sjzx = () => import(/* webpackChunkName: "Sjzx" */ '../sjzx/sjzx.vue');
const Yjgj = () => import(/* webpackChunkName: "Yjgj" */ '../tongue/tongue.vue');
const Project = () => import(/* webpackChunkName: "Main" */  '../project/project.vue');
const Model = () => import(/* webpackChunkName: "Main" */  '../model/model.vue');
const Aiyy = () => import(/* webpackChunkName: "Main" */  '../aiyy/aiyy.vue');
const Dig = () => import(/* webpackChunkName: "Main" */  '../dig/dig.vue');
const Zsk = () => import(/* webpackChunkName: "Main" */  '../zsk/zsk.vue');
const Szjx = () => import(/* webpackChunkName: "Main" */  '../shezhenjiaoxue/szjx.vue');
const Hdr = () => import(/* webpackChunkName:"Main" */ '../hdr/hdr.vue');
const Idr = () => import(/* webpackChunkName:"Main" */ '../idr/idr.vue');
const Cdr = () => import(/* webpackChunkName:"Main" */ '../cdr/cdr.vue');
const Edr = () => import(/* webpackChunkName:"Main" */ '../edr/edr.vue');
const Jxgl = () => import(/* webpackChunkName:"Jxgl"*/ '../jiaoxueguanli/jxgl.vue');
const Account = () => import(/* webpackChunkName:"Main" */ '../account/account.vue');

import SjzxRouters from "../sjzx/sjzx.router";
import YjgjRouters from "../tongue/tongue.router";
import ProjectRouters from "../project/project.router";
import ModelRouters from "../model/model.router";
import AiyyRouters from "../aiyy/aiyy.router";
import DigRouters from "../dig/dig.router";
import ZskRouters from "../zsk/zsk.router";
import SzjxRouters from "../shezhenjiaoxue/szjx.router";
import HdrRouters from "../hdr/hdr.router";
import IdrRouters from "../idr/idr.router";
import CdrRouters from "../cdr/cdr.router";
import EdrRouters from "../edr/edr.router";
import JxglRouters from "../jiaoxueguanli/jxgl.router";
import AccountRouters from "../account/account.router";

const routers: RouteConfig[] = [
    {
        path: "home",
        component: Home
    },
    {
        path: 'sjzx',
        component: Sjzx,
        children: SjzxRouters
    },
    {
        path: 'tongue',
        component: Yjgj,
        children: YjgjRouters
    },
    {
        path: 'project',
        component: Project,
        children: ProjectRouters
    },
    {
        path: 'model',
        component: Model,
        children: ModelRouters
    },
    {
        path: 'aiyy',
        component: Aiyy,
        children: AiyyRouters
    },
    {
        path: 'dig',
        component: Dig,
        children: DigRouters
    },
    {
        path: 'zsk',
        component: Zsk,
        children: ZskRouters
    },
    {
        path: 'szjx',
        component: Szjx,
        children: SzjxRouters
    },
    {
        path: 'hdr',
        component: Hdr,
        children: HdrRouters
    },
    {
        path: 'idr',
        component: Idr,
        children: IdrRouters
    },
    {
        path: 'cdr',
        component: Cdr,
        children: CdrRouters,

    },
    {
        path: 'edr',
        component: Edr,
        children: EdrRouters,

    },
    {
        path: 'jxgl',
        component: Jxgl,
        children: JxglRouters,

    },
    {
        path: 'account',
        component: Account,
        children: AccountRouters
    },
    {
        path: '',
        redirect: 'project'
    },
];

export default routers;
